import { makeAutoObservable } from "mobx";
import dict from "./statusInfoDictionary";

export class StatusInfo {
  constructor(status = "") {
    makeAutoObservable(this);

    this.status = status;
  }

  status = "";
  details: Record<string, Array<string>> | Array<string> = null;

  setStatus = (value = "") => {
    this.status = value;
  };

  setDetails = (
    value: Record<string, Array<string>> | Array<string> | Error = null,
  ) => {
    if (value instanceof Error) {
      value = this.getDetailsFromError(value);
    }
    this.details = value;
  };

  getDetailsFromError = (e): string[] => {
    if (!e.response) {
      console.log(e);
      return [];
    }
    let errors = e.response.data.errors;

    if (e.response.status === 500 || e.response.data.status === 500) {
      errors = [e.response.data.title];
    } else if (e.response.status === 403) {
      errors = ["У вас нет прав для доступа"];
    } else if (e.response.status === 404) {
      errors = [e.response.data];
    } else if (typeof errors === "object" && !Array.isArray(errors)) {
      errors = Object.entries(errors).reduce((acc, item) => {
        const [name, value] = item;
        if (typeof value === "string") {
          acc.push(`${dict[name] ?? name}: ${value}`);
        } else if (Array.isArray(value)) {
          for (let i = 0; i < value.length; i++) {
            acc.push(`${dict[name] ?? name}: ${value[i]}`);
          }
        }
        return acc;
      }, []);
    }

    return errors;
  };

  resetStatus = () => {
    this.setStatus();
    this.setDetails();
  };
}
